module.exports = __webpack_public_path__ + "img/Support_1.576b2f09.png";